export default __webpack_public_path__ + "img/customScreens.da5b1e31.png";